import gql from 'graphql-tag';

export const ContentTypesHeaderQuery = gql`
	query ContentTypesHeaderQuery($contentId: ID, $useObjectHeader: Boolean) {
		content(id: $contentId, status: ["archived", "current", "draft"]) {
			nodes {
				id
				title
				operations {
					operation
					targetType
				}
				space {
					id
					name
					key
					alias
				}
				type
				subType
				status
				version @include(if: $useObjectHeader) {
					by {
						displayName
					}
					contentTypeModified
					number
					when
					friendlyWhen
				}
				draftVersion @include(if: $useObjectHeader) {
					by {
						displayName
					}
					contentTypeModified
					number
					when
					friendlyWhen
				}
			}
		}
		user: confluence_atlassianUser(current: true) @include(if: $useObjectHeader) {
			id
			displayName
		}
	}
`;
